export enum ActionType {
  INCOMES_ADJUSTMENT = 'INCOMES_ADJUSTMENT',
  LIABILITIES_ADJUSTMENT = 'LIABILITIES_ADJUSTMENT',
  EXPENSES_ADJUSTMENT = 'EXPENSES_ADJUSTMENT',
  PROPERTY_ADJUSTMENT = 'PROPERTY_ADJUSTMENT',
}
